﻿import { ensureWOW } from "@js/core/loaders/vendors";

export async function initWowAnimations() {
    const wowElements = document.querySelectorAll(".wow");
    if (!wowElements.length) return;

    const WOW = await ensureWOW();
    if (!WOW) return;

    new WOW().init();
}